<template>
  <v-card>
    <v-card-title primary-title>
      <h3 class="headline mb-0">{{ provider }}</h3>
    </v-card-title>

    <v-card-text v-if="showError">
      <v-alert
      v-model="showError"
      type="error"
      icon="warning"
      dismissible>
        {{ errorMessage }}
      </v-alert>
    </v-card-text>

    <v-card-text v-if="providerData">
      <v-layout row wrap>
        <v-flex xs12 sm2>Avatar:</v-flex>
        <v-flex xs12 sm10>
          <v-avatar tile>
            <img :src="photoURL" :alt="displayName">
          </v-avatar>
        </v-flex>
        <v-flex xs12 sm2>Name:</v-flex>
        <v-flex xs12 sm10>{{ displayName }}</v-flex>
        <v-flex xs12 sm2>Email:</v-flex>
        <v-flex xs12 sm10>{{ email }}</v-flex>
      </v-layout>
    </v-card-text>

    <v-card-actions>

      <v-btn
      v-if="!providerData"
      @click="addProvider"
      :disabled="isUpdatingUser"
      block
      flat>
        <v-avatar tile size="18px" left>
          <img :src="providerImgUrl" :alt="provider">
        </v-avatar>
        Add {{ provider }} connection
      </v-btn>

      <v-spacer v-if="providerData"></v-spacer>

      <v-btn
      v-if="providerData"
      @click="removeProvider"
      :disabled="isUpdatingUser"
      flat>
        <v-avatar tile size="18px" left>
          <img :src="providerImgUrl" :alt="provider">
        </v-avatar>
        Remove {{ provider }} connection
      </v-btn>

    </v-card-actions>

  </v-card>
</template>

<script>
// import { /*mapGetters,*/ mapState } from 'vuex';
import { createNamespacedHelpers } from 'vuex'
const { mapState, mapActions } = createNamespacedHelpers('auth')
// import { firebase, auth } from '@/firebase.js';
  
export default {
  name: 'ProviderDetailsCard',
  data() {
    return {
      debug: false,

      showError: false,
      errorMessage: ''
    }
  },
  props: {
    provider: {
      type: String
    }
  },
  computed: {
    ...mapState({
      user: state => state.user, // map `this.user` to `this.$store.state.users.user`
      isUpdatingUser: state => state.isUpdatingUser, // map `this.user` to `this.$store.state.users.isUpdatingUser`
    }),

    providerLower() {
      return (this.provider && this.provider.toLowerCase ? this.provider.toLowerCase() : '');
    },
    providerImgUrl() {
      let images = require.context('@/assets/', false, /\.png$/)
      return images('./' + this.providerLower + '_64.png')
    },
    providerUrl() {
      return this.providerLower + '.com';
    },
    providerData() {
      if (!this.user || !this.user.providerData || !this.user.providerData.find) return false;
      let found = this.user.providerData.find((provider) => {
        return provider.providerId && provider.providerId === this.providerUrl;
      });
      return found;
    },
    photoURL() {
      return (this.providerData && this.providerData.photoURL ? this.providerData.photoURL : '');
    },
    displayName() {
      return (this.providerData && this.providerData.displayName ? this.providerData.displayName : '');
    },
    email() {
      return (this.providerData && this.providerData.email ? this.providerData.email : '');
    }
  },
  methods: {
    ...mapActions([
      'addUserProvider', // map `this.addUserProvider(providerName)` to `this.$store.dispatch('users/addUserProvider', providerName)`
      'removeUserProvider' // map `this.removeUserProvider(providerName)` to `this.$store.dispatch('users/removeUserProvider', providerName)`
    ]),

    addProvider() {
      if (this.debug) console.log(this.$options.name+'.addProvider() providerUrl:',this.providerUrl);
      this.addUserProvider(this.providerUrl)
      .then(() => {
        if (this.debug) console.log(this.$options.name+'.addProvider() provider added');
        this.showError = false;
      })
      .catch((error) => {
        if (this.debug) console.log(this.$options.name+'.addProvider() error:',error);
        if (error.message) this.errorMessage = error.message
        else this.errorMessage = error
        this.showError = true
      })
    },

    removeProvider() {
      if (this.debug) console.log(this.$options.name+'.removeProvider() providerUrl:',this.providerUrl);
      this.removeUserProvider(this.providerUrl)
      .then(() => {
        if (this.debug) console.log(this.$options.name+'.removeProvider() provider removed');
        this.showError = false;
      })
      .catch((error) => {
        if (this.debug) console.log(this.$options.name+'.removeProvider() error:',error);
        if (error.message) this.errorMessage = error.message
        else this.errorMessage = error
        this.showError = true
      })
    }

  }
}
</script>

<style scoped>  /* "scoped" attribute limit the CSS to this component only */
.v-avatar[left] {
  margin-right: 16px;
}
</style>